// import React, { useCallback, useEffect, useRef, useState } from "react";
// import Sidebar from "../components/Sidebar";
// import { config } from "../utils/config";
// import KEYS from "../env/env";
// import { doRequest } from "../utils/helper";
// // import secureLocalStorage from "react-secure-storage";
// import { useDropzone } from "react-dropzone";
// import SpinnerLoader from "../page/private/PolotnoDesign/SpinnerLoader";
// import { useDispatch } from "react-redux";
// import { showToast } from "../redux/slices/ToastSlice";

// export default function UploadFonts({
//   store,
//   onMouseEnter,
//   onMouseLeave,
//   setSelectedFont,
//   setOriginalFont,
//   setIsFirstHover,
//   searchQuery,
//   fontList,
//   getAllUploadedFontList,
//   loading,
// }) {
//   const [filteredFonts, setFilteredFonts] = useState([]);
//   const [selectedIndex1, setSelectedIndex1] = useState(null);

//   const dispatch = useDispatch();
//   const element = store.selectedElements[0];
//   const fontListRef = useRef([]);

//   const changeFontByIndex = (index, enter) => {
//     const sFont = filteredFonts[index];
//     if (sFont) {
//       element?.set({ fontFamily: sFont.name });
//       fontListRef.current[index]?.scrollIntoView({
//         behavior: "smooth",
//         block: "nearest",
//       });
//       if (enter) {
//         setSelectedFont(sFont.name);
//       }
//     }
//   };

//   const handleFontClick = (fontName) => {
//     // Apply the font permanently when clicked
//     element?.set({ fontFamily: fontName });
//     setSelectedFont(fontName);
//     setOriginalFont(fontName); // Update the original font to the newly selected font
//     setIsFirstHover(false); // Set first hover to false when user clicks
//     element?.canvas?.requestRenderAll();
//   };

//   const handleMouseEnter = (fontName) => {
//     // Set first hover to false on first interaction
//     setIsFirstHover(false);
//     onMouseEnter(fontName);
//   };

//   const saveFontFunc = async (e) => {
//     const selectedFiles = e.target.files;
//     if (selectedFiles.length > 10) {
//       // alert("You can only upload up to 10 files at a time.");
//       dispatch(
//         showToast({
//           message: "You can only upload up to 10 files at a time.",
//           type: "",
//         })
//       );
//       e.target.value = ""; // Clear the selected files
//       return;
//     }

//     if (!selectedFiles.length) {
//       // alert("Please select at least one font file.");
//       dispatch(
//         showToast({
//           message: "Please select at least one font file.",
//           type: "",
//         })
//       );
//       return;
//     }

//     try {
//       const user = localStorage.getItem(config.USER_LOGIN_DETAILS);
//       if (!user || user === "undefined") {
//         alert("Please login to upload fonts");
//         return;
//       }

//       // const userLogin = JSON.parse(user);
//       const fontdata = new FormData();

//       // ✅ Append each selected file
//       for (let i = 0; i < selectedFiles.length; i++) {
//         fontdata.append("file", selectedFiles[i]);
//       }

//       // fontdata.append("uploaded_by", userLogin?.id);

//       // const token = secureLocalStorage.getItem("Login");
//       const token = localStorage.getItem("Login");

//       const requestOptions = {
//         method: "POST",
//         body: fontdata,
//         headers: {
//           Authorization: `Bearer ${token}`,
//           // ✅ Don't set Content-Type — let browser do it
//         },
//       };

//       const res = await fetch(`${KEYS.apiPath}font/save`, requestOptions);
//       const response = await res.json();

//       if (response?.resultFlag === 1) {
//         getAllUploadedFontList();
//         // alert(response?.message || "Fonts uploaded successfully!");
//         dispatch(
//           showToast({
//             message: response?.message || "Fonts uploaded successfully!",
//             type: "",
//           })
//         );
//       } else {
//         dispatch(
//           showToast({
//             message: response?.message || "Something went wrong!",
//             type: "",
//           })
//         );
//         // alert(response?.message || "Something went wrong!");
//       }
//     } catch (error) {
//       console.error("Upload Error:", error);
//       alert(error?.message || "Something went wrong!");
//     }
//   };

//   const onDrop = useCallback((acceptedFiles) => {
//     const eventLike = {
//       target: {
//         files: acceptedFiles,
//       },
//     };
//     saveFontFunc(eventLike);
//   }, []);

//   const { getRootProps, getInputProps, open } = useDropzone({
//     accept: {
//       "font/ttf": [".ttf"],
//       "font/otf": [".otf"],
//       "font/woff": [".woff"],
//       "font/woff2": [".woff2"],
//     },
//     multiple: true,
//     noClick: true,
//     noKeyboard: true,
//     onDrop,
//   });

//   const deleteFontHandler = async (id) => {
//     try {
//       let data = {
//         id,
//       };
//       let response = await doRequest(data, "POST", "font/delete");
//       if (+response?.resultFlag === 1) {
//         alert("font deleted");
//         getAllUploadedFontList();
//       }
//     } catch (error) {}
//   };

//   console.log("fontList", fontList);
//   useEffect(() => {
//     const filtered = fontList.filter((font) =>
//       font.name.toLowerCase().includes(searchQuery.toLowerCase())
//     );
//     setFilteredFonts(filtered);
//   }, [searchQuery, fontList]);

//   useEffect(() => {
//     const handleArrowNavigation = (e) => {
//       if (loading || filteredFonts.length === 0) return;
//       let defaultIndex = filteredFonts.findIndex(
//         (font) => font.name === store.selectedElements[0]?.fontFamily
//       );
//       let indexinside;
//       if (e.key === "ArrowDown") {
//         e.preventDefault();
//         setSelectedIndex1((prev) => {
//           const nextIndex = Math.min(
//             filteredFonts.length - 1,
//             (prev ? prev : defaultIndex) + 1
//           );
//           changeFontByIndex(nextIndex);
//           indexinside = nextIndex;
//           return nextIndex;
//         });
//       }

//       if (e.key === "ArrowUp") {
//         e.preventDefault();
//         setSelectedIndex1((prev) => {
//           const nextIndex = Math.max(0, (prev ? prev : defaultIndex) - 1);
//           changeFontByIndex(nextIndex);
//           indexinside = nextIndex;
//           return nextIndex;
//         });
//       }
//       console.log("selectedIndex1", selectedIndex1);
//       // if (e.key === "Enter") {
//       //   e.preventDefault();
//       //   changeFontByIndex(indexinside, "enter"); // ✅ Call your function with the active index
//       // }
//     };

//     document.addEventListener("keydown", handleArrowNavigation);
//     return () => document.removeEventListener("keydown", handleArrowNavigation);
//   }, [filteredFonts, loading]);

//   return (
//     <>
//       {/* <div id="main-container" className="container-fluid main"> */}
//       {/* <Sidebar></Sidebar> */}
//       <div className="font_pos">
//         {/* <h1 className="text-center">Upload Your Fonts</h1> */}
//         <ul className="options option_font">
//           {loading ? (
//             <SpinnerLoader loading={loading} />
//           ) : filteredFonts.length > 0 ? (
//             filteredFonts.map((option, index) => (
//               <li
//                 key={index}
//                 ref={(el) => (fontListRef.current[index] = el)}
//                 onClick={() => {
//                   handleFontClick(option.name);
//                 }}
//                 onMouseEnter={() => handleMouseEnter(option.name)}
//                 onMouseLeave={() => onMouseLeave()}
//                 role="option"
//                 aria-selected={
//                   store.selectedElements[0]?.fontFamily === option.name
//                 }
//               >
//                 <ul style={{ cursor: "pointer" }} className="customFontList">
//                   <li
//                     className={
//                       store.selectedElements[0]?.fontFamily === option.name
//                         ? "selectedFont"
//                         : "fontlisthover"
//                     }
//                   >
//                     <sup>{option.name}</sup>
//                     <span>
//                       <p style={{ fontFamily: option.name }}>
//                         {store.selectedElements[0]?.text}
//                       </p>
//                       <span
//                         onClick={() => deleteFontHandler(option.id)}
//                         className="ml-6 delete-font"
//                       >
//                         <img
//                           src={"/assets/images/delete-font-icn.svg"}
//                           alt="Varient logo"
//                           className="sidebar-logo-main"
//                         />
//                       </span>
//                     </span>
//                   </li>
//                 </ul>
//               </li>
//             ))
//           ) : (
//             //<p>No fonts found</p>
//             <div className="uploadFontNoData dragingFont">
//               <div className="fontUploadButton">
//                 <div {...getRootProps()}>
//                   {/* Hidden file input */}

//                   <img
//                     src={"/assets/images/uploadFontsIcon.svg"}
//                     alt="No Font Found"
//                     className="no-data-img"
//                   />
//                   <input {...getInputProps()} />
//                   <h3>Drag and drop files to upload</h3>
//                   <p>
//                     A maximum of 10 fonts can be uploaded at a time. Supported
//                     formats: TTF, OTF, WOFF, or WOFF2.
//                   </p>
//                 </div>
//               </div>
//             </div>
//           )}
//         </ul>

//         {/* <div className="fontUploadButton">
//           <div {...getRootProps()}>
//             <input {...getInputProps()} />

//             <button type="button" className="dummyUploadButton" onClick={open}>
//               <img
//                 src={"/assets/images/upload-icn.svg"}
//                 className="nextarrow"
//                 alt=""
//               />
//               Upload Fonts
//             </button>
//           </div>

//         </div> */}
// <div className="dropzone dropzone_fileupload">
//         <div
//           {...getRootProps({
//             className: "dropzone-upload-wrapper fontUploadButton",
//           })}
//         >
//           <input {...getInputProps()} />
//           <div className="dropzone-inner-wrapper">
//             <button type="button" className="dummyUploadButton">
//               <img
//                 src={"/assets/images/upload-icn.svg"}
//                 className="nextarrow"
//                 alt=""
//               />
//               Upload Fonts
//             </button>
//           </div>
//         </div>
//         </div>
//         {/* <div className="row fontUploadButton" style={{ display: "none" }}>
//           <div className="col-md-12">
//             <div className="input-group mb-3">
//               <input
//                 type="file"
//                 className="form-control"
//                 multiple
//                 id="inputGroupFile02"
//                 // value={files}
//                 accept=".ttf,.otf,.woff,.woff2"
//                 onChange={(e) => saveFontFunc(e)}
//               />
//               <label className="input-group-text" htmlFor="inputGroupFile02">
//                 Upload
//               </label>
//             </div>
//           </div>
//         </div> */}
//       </div>
//       {/* </div> */}
//     </>
//   );
// }

import React, { useCallback, useEffect, useRef, useState } from "react";
import Sidebar from "../components/Sidebar";
import { config } from "../utils/config";
import KEYS from "../env/env";
import { doRequest } from "../utils/helper";
// import secureLocalStorage from "react-secure-storage";
import { useDropzone } from "react-dropzone";
import SpinnerLoader from "../page/private/PolotnoDesign/SpinnerLoader";
import { useDispatch } from "react-redux";
import { showToast } from "../redux/slices/ToastSlice";
import DragDrop from "./DragDrop";

export default function UploadFonts({
  store,
  onMouseEnter,
  onMouseLeave,
  setSelectedFont,
  setOriginalFont,
  setIsFirstHover,
  searchQuery,
  fontList,
  getAllUploadedFontList,
  loading,
  previewFontSize
}) {
  const [filteredFonts, setFilteredFonts] = useState([]);
  const [selectedIndex1, setSelectedIndex1] = useState(null);

  const dispatch = useDispatch();
  const element = store.selectedElements[0];
  const fontListRef = useRef([]);

  const changeFontByIndex = (index, enter) => {
    const sFont = filteredFonts[index];
    if (sFont) {
      element?.set({ fontFamily: sFont.name });
      fontListRef.current[index]?.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
      if (enter) {
        setSelectedFont(sFont.name);
      }
    }
  };

  const handleFontClick = (fontName) => {
    // Apply the font permanently when clicked
    element?.set({ fontFamily: fontName });
    setSelectedFont(fontName);
    setOriginalFont(fontName); // Update the original font to the newly selected font
    setIsFirstHover(false); // Set first hover to false when user clicks
    element?.canvas?.requestRenderAll();
  };

  const handleMouseEnter = (fontName) => {
    // Set first hover to false on first interaction
    setIsFirstHover(false);
    onMouseEnter(fontName);
  };

  const saveFontFunc = async (e) => {
    const selectedFiles = e.target.files;
    if (selectedFiles.length > 10) {
      // alert("You can only upload up to 10 files at a time.");
      dispatch(
        showToast({
          message: "You can only upload up to 10 files at a time.",
          type: "",
        })
      );
      e.target.value = ""; // Clear the selected files
      return;
    }

    if (!selectedFiles.length) {
      // alert("Please select at least one font file.");
      dispatch(
        showToast({
          message: "Please select at least one font file.",
          type: "",
        })
      );
      return;
    }

    try {
      const user = localStorage.getItem(config.USER_LOGIN_DETAILS);
      if (!user || user === "undefined") {
        alert("Please login to upload fonts");
        return;
      }

      // const userLogin = JSON.parse(user);
      const fontdata = new FormData();

      // ✅ Append each selected file
      for (let i = 0; i < selectedFiles.length; i++) {
        fontdata.append("file", selectedFiles[i]);
      }

      // fontdata.append("uploaded_by", userLogin?.id);

      // const token = secureLocalStorage.getItem("Login");
      const token = localStorage.getItem("Login");

      const requestOptions = {
        method: "POST",
        body: fontdata,
        headers: {
          Authorization: `Bearer ${token}`,
          // ✅ Don't set Content-Type — let browser do it
        },
      };

      const res = await fetch(`${KEYS.apiPath}font/save`, requestOptions);
      const response = await res.json();

      if (response?.resultFlag === 1) {
        getAllUploadedFontList();
        // alert(response?.message || "Fonts uploaded successfully!");
        dispatch(
          showToast({
            message: response?.message || "Fonts uploaded successfully!",
            type: "",
          })
        );
      } else {
        dispatch(
          showToast({
            message: response?.message || "Something went wrong!",
            type: "",
          })
        );
        // alert(response?.message || "Something went wrong!");
      }
    } catch (error) {
      console.error("Upload Error:", error);
      alert(error?.message || "Something went wrong!");
    }
  };
  const onDrop = useCallback((acceptedFiles) => {
    const eventLike = {
      target: {
        files: acceptedFiles,
      },
    };
    saveFontFunc(eventLike);
  }, [saveFontFunc]);

  const { getRootProps, getInputProps, open } = useDropzone({
    accept: {
      "font/ttf": [".ttf"],
      "font/otf": [".otf"],
      "font/woff": [".woff"],
      "font/woff2": [".woff2"],
    },
    multiple: true,
    noClick: true,
    noKeyboard: true,
    onDrop,
  });

  const deleteFontHandler = async (id) => {
    try {
      let data = {
        id,
      };
      let response = await doRequest(data, "POST", "font/delete");
      if (+response?.resultFlag === 1) {
        alert("font deleted");
        getAllUploadedFontList();
      }
    } catch (error) { }
  };
  const handleDrop = (event) => {
  event.preventDefault();

  const files = Array.from(event.dataTransfer.files);
  if (files && files.length > 0) {
    onDrop(files); // reuse your existing logic
  }
};


  useEffect(() => {
    const filtered = fontList.filter((font) =>
      font.name.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredFonts(filtered);
  }, [searchQuery, fontList]);

  useEffect(() => {
    const handleArrowNavigation = (e) => {
      if (loading || filteredFonts.length === 0) return;
      let defaultIndex = filteredFonts.findIndex(
        (font) => font.name === store.selectedElements[0]?.fontFamily
      );
      let indexinside;
      if (e.key === "ArrowDown") {
        e.preventDefault();
        setSelectedIndex1((prev) => {
          const nextIndex = Math.min(
            filteredFonts.length - 1,
            (prev ? prev : defaultIndex) + 1
          );
          changeFontByIndex(nextIndex);
          indexinside = nextIndex;
          return nextIndex;
        });
      }

      if (e.key === "ArrowUp") {
        e.preventDefault();
        setSelectedIndex1((prev) => {
          const nextIndex = Math.max(0, (prev ? prev : defaultIndex) - 1);
          changeFontByIndex(nextIndex);
          indexinside = nextIndex;
          return nextIndex;
        });
      }
      console.log("selectedIndex1", selectedIndex1);
      // if (e.key === "Enter") {
      //   e.preventDefault();
      //   changeFontByIndex(indexinside, "enter"); // ✅ Call your function with the active index
      // }
    };

    document.addEventListener("keydown", handleArrowNavigation);
    return () => document.removeEventListener("keydown", handleArrowNavigation);
  }, [filteredFonts, loading]);

  useEffect(() => {
    const handleDragOver = (e) => {
      e.preventDefault();
    };

    const handleDrop = (e) => {
      e.preventDefault();
    };

    window.addEventListener("dragover", handleDragOver);
    window.addEventListener("drop", handleDrop);

    return () => {
      window.removeEventListener("dragover", handleDragOver);
      window.removeEventListener("drop", handleDrop);
    };
  }, []);

  return (
    <>
      {/* <div id="main-container" className="container-fluid main"> */}
      {/* <Sidebar></Sidebar> */}
      <div className="font_pos">
        {/* <h1 className="text-center">Upload Your Fonts</h1> */}
        <ul className="options option_font" onDrop={handleDrop}
          onDragOver={(e) => e.preventDefault()}
          onDragEnter={(e) => e.preventDefault()}>
          {loading ? (
            <SpinnerLoader loading={loading} />
          ) : filteredFonts.length > 0 ? (
            filteredFonts.map((option, index) => (
              <li
                key={index}
                ref={(el) => (fontListRef.current[index] = el)}
                onClick={() => {
                  handleFontClick(option.name);
                }}
                onMouseEnter={() => handleMouseEnter(option.name)}
                onMouseLeave={() => onMouseLeave()}
                role="option"
                aria-selected={
                  store.selectedElements[0]?.fontFamily === option.name
                }
              >
                <ul style={{ cursor: "pointer" }} className="customFontList">
                  <li
                    className={
                      store.selectedElements[0]?.fontFamily === option.name
                        ? "selectedFont"
                        : "fontlisthover"
                    }
                  >
                    <sup>{option.name}</sup>
                    <span>
                      <p style={{ fontFamily: option.name , fontSize: `${previewFontSize}px`,}}>
                        {store.selectedElements[0]?.text}
                      </p>
                      <span
                        onClick={() => deleteFontHandler(option.id)}
                        className="ml-6 delete-font"
                      >
                        <img
                          src={"/assets/images/delete-font-icn.svg"}
                          alt="Varient logo"
                          className="sidebar-logo-main"
                        />
                      </span>
                    </span>
                  </li>
                </ul>
              </li>
            ))
          ) : (
            //<p>No fonts found</p>
            // <div className="uploadFontNoData dragingFont">
            //   <img
            //     src={"/assets/images/uploadFontsIcon.svg"}
            //     alt="No Font Found"
            //     className="no-data-img" />
            //     <h3>No uploaded image found</h3>
            //     {/* <p>A maximum of 10 fonts can be uploaded at a time. 
            //     Supported formats: TTF, OTF, WOFF, or WOFF2.</p> */}
            // </div>
            <DragDrop onDrop={onDrop} />
          )}
        </ul>

        <div className="fontUploadButton">
          <div {...getRootProps()}>
            {/* Hidden file input */}
            <input {...getInputProps()} />

            {/* Your existing custom button */}
            <button type="button" className="dummyUploadButton" onClick={open}>
              <img
                src={"/assets/images/upload-icn.svg"}
                className="nextarrow"
                alt=""
              />
              Upload Fonts
            </button>
          </div>

          {/* <button className="dummyUploadButton">
            <img
              src={"/assets/images/upload-icn.svg"}
              className="nextarrow"
              alt=""
            />
            Upload Fonts
          </button> */}
          {/* <div
              {...getRootProps()}
              className="dropzone border p-4 text-center rounded cursor-pointer"
            >
              <input {...getInputProps()} />
              
            </div> */}
        </div>
        <div className="row fontUploadButton" style={{ display: "none" }}>
          <div className="col-md-12">
            <div className="input-group mb-3">
              <input
                type="file"
                className="form-control"
                multiple
                id="inputGroupFile02"
                // value={files}
                accept=".ttf,.otf,.woff,.woff2"
                onChange={(e) => saveFontFunc(e)}
              />
              <label className="input-group-text" htmlFor="inputGroupFile02">
                Upload
              </label>
            </div>
          </div>
        </div>
      </div>
      {/* </div> */}
    </>
  );
}
